import useCurrencies from './hooks/useCurrencies'

export default function MobileCurrencySelector() {
  const { currency, changeCurrency, currenciesCodesList } = useCurrencies()

  const currencyHandler = (e) => {
    changeCurrency(e.target.value)
  }
  return (
    <select id='currency-select' onChange={currencyHandler}>
      {currenciesCodesList.map((currencyKey) => (
        <option
          key={currencyKey}
          value={currencyKey}
          defaultValue={currency}
        >
          { currencyKey }
        </option>
      ))}
    </select>
  )
}
